import React, { useState, useEffect } from 'react';
import { getMasterTemplate, saveMasterTemplate, getSystemStatus } from '../../api/moduleApi';
import QuestionTemplateManager from '../../components/ui/QuestionTemplateManager.jsx';

const DEFAULT_MASTER_TEMPLATE = [
  { id: "A1", type: "Rating", text: "Clarity of module objectives (1-5)?", mandatory: true, scale: 5 },
  { id: "A2", type: "Rating", text: "Quality of teaching delivery (1-5)?", mandatory: true, scale: 5 },
  { id: "A3", type: "Text", text: "What did you find most valuable about the module?", mandatory: false }
];

const TemplateManagement = () => (
  <QuestionTemplateManager
    title="Master Template Management"
    description="Manage the standardized core questions required for all module evaluations."
    getTemplateFn={getMasterTemplate}
    saveTemplateFn={saveMasterTemplate}
    getSystemStatusFn={getSystemStatus}
    defaultTemplate={DEFAULT_MASTER_TEMPLATE}
    templateType="master"
  />
);

export default TemplateManagement;
